/**
 * @prop {object} exportData - an object contains the api link and label for export
 * @prop {string} exportData.api - the api link for export
 * @prop {string} exportData.label - the label for export
 */

import { ExcelIcon } from "@/constant/imagePath";
import React from "react";
import { useModalConfirmation } from "@/context/ModalConfirmationContext";
import { CONFIRMATION_MODAL_TYPES } from "@/Modals/NewConfirmationModal/constants";

function BaseExportZip({ exportZipData }) {
  const { openModalConfirmation } = useModalConfirmation();

  const handleExport = () => {
    openModalConfirmation({
      type: CONFIRMATION_MODAL_TYPES.EXPORT_ZIP,
      apiURL: exportZipData?.api,
      title: exportZipData?.label,
    });
  };
  return (
    <>
      <button
        onClick={handleExport}
        className="h-8 w-[120px] flex items-center justify-center gap-x-2 font-extralight text-sm text-white hover:underline underline-offset-1 rounded-7 bg-gradient-to-r from-gray-500 via-slate-400 to-gray-700 shadow-primary-inset"
      >
        <img src={ExcelIcon} className="h-4" alt="ExcelIcon" />
        <span>.zip Export</span>
      </button>
    </>
  );
}

export default BaseExportZip;
